import React from "react";

const HelpSearch = () => (
  <section className="w-full bg-white py-8 px-6 text-center">
    <div className="max-w-2xl mx-auto">
      <input
        type="text"
        placeholder="🔍 Rechercher une réponse…"
        className="w-full border border-light-2 rounded-full py-3 px-5 text-normal shadow focus:outline-none focus:ring-2 focus:ring-blue-1"
      />
    </div>
  </section>
);

export default HelpSearch;
